import { render, staticRenderFns } from "./CurriculumVitae.vue?vue&type=template&id=2697bd05"
import script from "./CurriculumVitae.vue?vue&type=script&lang=js"
export * from "./CurriculumVitae.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports